import { useRef } from 'react';
import { techLogos } from '../techLogos';

export default function SkillsCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    const track = trackRef.current;
    if (!track) return;
    const amount = Math.round(track.clientWidth * 0.8) * (direction === 'left' ? -1 : 1);
    track.scrollBy({ left: amount, behavior: 'smooth' });
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <button
        type="button"
        className="app-scroll-btn"
        aria-label="Scroll technologies left"
        onClick={() => scroll('left')}
      >
        &#8592;
      </button>

      <div className="app-logo-strip" ref={trackRef} role="list" aria-label="Technologies and languages I use">
        {techLogos.map((logo) => (
          <div key={logo.name} className="app-logo-card" role="listitem">
            {logo.path || logo.paths ? (
              <svg viewBox={logo.viewBox ?? '0 0 24 24'} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <g transform={logo.transform} fill={logo.hex}>
                  {logo.paths
                    ? logo.paths.map((d, i) => <path key={i} d={d} />)
                    : <path d={logo.path} />}
                </g>
              </svg>
            ) : (
              <span
                aria-hidden="true"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 28,
                  height: 28,
                  flexShrink: 0,
                  borderRadius: '50%',
                  background: logo.hex,
                  color: '#ffffff',
                  fontWeight: 700,
                  fontSize: '0.9rem'
                }}
              >
                {logo.initials}
              </span>
            )}
            <span className="govuk-body govuk-!-margin-bottom-0 govuk-!-font-weight-bold">{logo.name}</span>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="app-scroll-btn"
        aria-label="Scroll technologies right"
        onClick={() => scroll('right')}
      >
        &#8594;
      </button>
    </div>
  );
}
